import { setMeta } from '@/router/middleware'
import routerView from '@/router/routerView'


const Setup = () => import('@/views/setup/Setup')
const StoreInformation = () => import('@/views/setup/steps/StoreInformation')
const SetBanner = () => import('@/views/setup/steps/SetBanner')
const SetCommission = () => import('@/views/setup/steps/SetCommission')
const ChargeAccount = () => import('@/views/setup/steps/ChargeAccount')
const ImplementScript = () => import('@/views/setup/steps/ImplementScript')
const Finish = () => import('@/views/setup/steps/Finish')
const Suspended = () => import('@/views/setup/steps/Suspended')
const PersonalInformation = () => import('@/views/setup/steps/PersonalInformation')
const FinancialInformation = () => import('@/views/setup/steps/FinancialInformation')
const SubmitMedia = () => import('@/views/setup/steps/SubmitMedia')
const SubmitActivityArea = () => import('@/views/setup/steps/SubmitActivityArea')
const AcceptAgreement = () => import('@/views/setup/steps/AcceptAgreement')


import ticketRouterView from '@/views/tickets/routerView'
const TicketList = () => import ('@/views/tickets/List')
const TicketDetails = () => import ('@/views/tickets/Details')
const TicketCreate = () => import('@/views/tickets/Create')

export default {
    path: 'setup',
    name: 'setup',
    redirect: 'setup/steps',
    component: routerView,
    children: [
        {
            path: '/setup/steps',
            name: 'setup.steps',
            component: Setup,
            meta: {
                labelTrans: 'setup._',
            },
            children: [
                {
                    path: 'step=personal-information',
                    name: 'setup.steps.personal_information',
                    component: PersonalInformation,
                    meta: {
                        middleware: [setMeta],
                        labelTrans: 'setup.steps.personal_information',
                    }
                },
                {
                    path: 'step=financial-information',
                    name: 'setup.steps.financial_information',
                    component: FinancialInformation,
                    meta: {
                        middleware: [setMeta],
                        labelTrans: 'setup.steps.financial_information',
                    }
                },
                {
                    path: 'step=submit-media',
                    name: 'setup.steps.submit_media',
                    component: SubmitMedia,
                    meta: {
                        middleware: [setMeta],
                        labelTrans: 'setup.steps.submit_media',
                    }
                },
                {
                    path: 'step=submit-activity-area',
                    name: 'setup.steps.submit_activity_area',
                    component: SubmitActivityArea,
                    meta: {
                        middleware: [setMeta],
                        labelTrans: 'setup.steps.submit_activity_area',
                    }
                },
                {
                    path: 'step=store-information',
                    name: 'setup.steps.store_information',
                    component: StoreInformation,
                    meta: {
                        middleware: [setMeta],
                        labelTrans: 'setup.steps.store_information',
                    }
                },
                {
                    path: 'step=set-banner',
                    name: 'setup.steps.set_banner',
                    component: SetBanner,
                    meta: {
                        middleware: [setMeta],
                        labelTrans: 'setup.steps.set_banner',
                    }
                },
                {
                    path: 'step=set-commission',
                    name: 'setup.steps.set_commission',
                    component: SetCommission,
                    meta: {
                        middleware: [setMeta],
                        labelTrans: 'setup.steps.set_commission',
                    }
                },
                {
                    path: 'step=implement-script',
                    name: 'setup.steps.implement_script',
                    component: ImplementScript,
                    meta: {
                        middleware: [setMeta],
                        labelTrans: 'setup.steps.implement_script',
                    }
                },
                {
                    path: 'step=charge-account',
                    name: 'setup.steps.charge_account',
                    component: ChargeAccount,
                    meta: {
                        middleware: [setMeta],
                        labelTrans: 'setup.steps.charge_account',
                    }
                },
                {
                    path: 'step=accept-agreement',
                    name: 'setup.steps.accept_agreement',
                    component: AcceptAgreement,
                    meta: {
                        middleware: [setMeta],
                        labelTrans: 'setup.steps.accept_agreement',
                    }
                },
                {
                    path: 'step=finish',
                    name: 'setup.steps.finish',
                    component: Finish,
                    meta: {
                        middleware: [setMeta],
                        labelTrans: 'setup.steps.finish',
                    }
                },
                {
                    path: 'step=suspended',
                    name: 'setup.steps.suspended',
                    component: Suspended,
                    meta: {
                        middleware: [setMeta],
                        labelTrans: 'setup.steps.suspended',
                    }
                },

                {
                    path: 'step=tickets',
                    redirect: 'step=tickets',
                    component: ticketRouterView,
                    children: [
                        {
                            path: '',
                            name: 'setup.tickets',
                            component: TicketList,
                            meta: {
                                middleware: [setMeta],
                                labelTrans: 'ticket.plural',
                                rules: {
                                    //
                                },
                            }
                        },
                        {
                            path: 'step=tickets/create',
                            name: 'setup.tickets.create',
                            component: TicketCreate,
                            meta: {
                                middleware: [setMeta],
                                labelTrans: 'ticket.create',
                                rules: {
                                    //
                                },
                            }
                        },
                        {
                            path: 'step=tickets/details/:id',
                            name: 'setup.tickets.details',
                            component: TicketDetails,
                            meta: {
                                middleware: [setMeta],
                                labelTrans: 'ticket.details',
                                rules: {
                                    //
                                },
                            }
                        },
                    ]
                },
            ]
        }
    ]
}